<template>
    <div>
        <div v-if="isLoading" class="intelligence-state">
            <common-loader :isProcessing="true"></common-loader>
            <span>{{ $t('pages.intelligence.patient_friction.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.patient_friction.error') }}
        </div>

        <template v-else-if="patientFriction">
            <intelligence-patient-friction-kpi-cards :kpis="patientFriction.kpis"></intelligence-patient-friction-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-patient-friction-chart :actions="patientFriction.actions"></intelligence-patient-friction-chart>
                <intelligence-patient-friction-table :actions="patientFriction.actions"></intelligence-patient-friction-table>
            </div>
        </template>
    </div>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligencePatientFrictionKpiCards from 'components/page-elements/intelligence/IntelligencePatientFrictionKpiCards'
    import IntelligencePatientFrictionChart from 'components/page-elements/intelligence/IntelligencePatientFrictionChart'
    import IntelligencePatientFrictionTable from 'components/page-elements/intelligence/IntelligencePatientFrictionTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligencePatientFrictionKpiCards,
            IntelligencePatientFrictionChart,
            IntelligencePatientFrictionTable,
        },

        props: {
            filters: { type: Object, default: null },
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                patientFriction: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.patient_friction.title')
            },
        },

        methods: {
            loadPatientFriction() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getPatientFriction(this.filters)
                    .then((response) => {
                        this.patientFriction = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.patientFriction = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        watch: {
            filters: {
                immediate: true,
                handler() {
                    this.loadPatientFriction()
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
